module.exports = __webpack_public_path__ + "img/register.0455e46f.png";